module.exports = __webpack_public_path__ + "img/logo-ppg-pis-ufmg.3a66bba0.png";